import { WithGlobalCss } from "@sgwt-widget/core";
import { ColDef, IHeader } from "ag-grid-community";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise/main";
import { AgGridReact } from "ag-grid-react";
import { Component, h } from "preact";
import * as XLSX from "xlsx";
import * as css from "./agGrid.less";
import { autoGroupColumnDef, defaultColDef } from "./helpers";

LicenseManager.setLicenseKey(
  "SHI_International_France__on_behalf_of_SOCIETE_GENERALE_ICT_3Devs9_November_2019__MTU3MzI1NzYwMDAwMA==8f57eed23862f998eb312fb7c1120e18"
);

export interface IProps {
  columnDefs?: IHeader[] | any;
  rowData?: any[] | any;
  onColumnConfigChanged?: (columnsConfig: ColDef[]) => void;
}

export interface IState {
  rowData: any;
}

export const Grid = class extends Component<IProps, IState> {
  private gridApi?: any;
  private gridColumnApi: any;
  constructor() {
    super();
  }

  public render(): JSX.Element {
    const { columnDefs } = this.props;

    return (
      <WithGlobalCss styles={css}>
        <div
          class={`${css.locals.splAgGridBasic}`}
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          <button
            style="margin-bottom: 10px; margin-top: 0px;"
            class="btn sgbs-btn-default"
            onClick={() => this.onBtnExport()}
          >
            <span class="fa fa-file-excel-o" /> Export
          </button>
          <div
            class={"ag-theme-balham"}
            style={{
              height: "90%",
              width: "100%",
            }}
          >
            <AgGridReact
              ref={(agGridReact: any) => {
                this.gridApi = agGridReact;
              }}
              onGridReady={this.onGridReady}
              sideBar={false}
              suppressHorizontalScroll={true}
              suppressDragLeaveHidesColumns={true}
              suppressRowDrag={true}
              columnDefs={columnDefs}
              rowData={this.state.rowData}
              defaultColDef={defaultColDef}
              groupDefaultExpanded={-1}
              pivotMode={true}
              pivotTotals={true}
              pagination={true}
              suppressCsvExport={true}
              suppressExcelExport={true}
              rowGroupPanelShow="always"
              suppressAggFuncInHeader={true}
              autoGroupColumnDef={autoGroupColumnDef}
              groupIncludeTotalFooter={true}
              onDragStopped={this.handleColumnConfigChanged.bind(this)}
              onColumnResized={this.handleColumnConfigChanged.bind(this)}
            />
            <div style="align: right">
              <b>Units: SC(K€)</b>
            </div>
          </div>
        </div>
      </WithGlobalCss>
    );
  }

  public onGridReady = (params: any) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ rowData: this.props.rowData });
    this.gridApi.sizeColumnsToFit();
  };

  private handleColumnConfigChanged() {
    const rowGroupColumns = this.gridApi.gridOptions.columnApi.columnController
      .rowGroupColumns;

    const columns = this.gridApi.gridOptions.columnApi.columnController.allDisplayedColumns.map(
      (elem: any) => {
        if (elem.colId === "ag-Grid-AutoColumn") {
          return rowGroupColumns.map((childElement: any) => {
            return {
              colId: childElement.colId,
              pinned: childElement.pinned,
              width: elem.actualWidth,
            };
          });
        }
        return {
          colId: elem.colId,
          pinned: elem.pinned,
          width: elem.actualWidth,
        };
      }
    );
    const columnsResult: ColDef[] = [];
    columns.forEach((element: ColDef) => {
      if (Array.isArray(element) && element.length > 0) {
        (element as ColDef[]).forEach(x => {
          columnsResult.push(x);
        });
      } else {
        columnsResult.push(element);
      }
    });

    if (this.props.onColumnConfigChanged) {
      this.props.onColumnConfigChanged(columnsResult);
    }
  }

  private onBtnExport() {
    const colDefs = this.gridApi.gridOptions.columnDefs;
    const xlsxHeaders: any[] = colDefs.map((x: any) => x.headerName);
    const xlsxData: any[] = [];
    xlsxData.push(xlsxHeaders);
    this.state.rowData.forEach((element: any) => {
      const row: string[] = [];
      colDefs.forEach((clmn: any) => {
        row.push(element[clmn.field]);
      });
      xlsxData.push(row);
    });
    const workSheet = XLSX.utils.aoa_to_sheet(xlsxData);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "salesCredit");
    XLSX.writeFile(workBook, "salesCredit.xlsx");
  }
};
